import { GET_ERRORS, CLEAR_ERRORS } from "./errorTypes";

/**
 * Push an error payload into the shared `state.errors` slice so the shell-level
 * hub (`GlobalNotifications`, SCRUM-857/883) surfaces it as a toast. Use this
 * when a component catches a failure that does NOT already route through a
 * thunk's `GET_ERRORS` dispatch — notably the fetch-based image uploads, whose
 * re-thrown plain `Error` reaches neither `globalRejectionNet` nor a reducer, so
 * a failed upload was otherwise dropped silently (SCRUM-1021).
 *
 * Pass a shape `getErrorMessage` understands: `{ message }`, `{ msg }`,
 * `{ errors: [{ msg }] }`, or a string. `{ message: err.message }` is the
 * natural fit for a caught `Error`.
 *
 * @param {unknown} payload
 */
export const setErrors = (payload) => (dispatch) => {
  dispatch({
    type: GET_ERRORS,
    payload,
  });
};

export const clearErrors = () => (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};
